// extracted by mini-css-extract-plugin
export default {"iconUpload":"YesNo_iconUpload__cRTYM"};